import { CalculatePage,CargoStatusPage, ForwardinReceiptPage } from '@/pages/';
import { createRouter, createWebHistory } from 'vue-router';
import { default as newCargoPickUpPage } from '../newCargoPickUpPage/CargoPickupPage.vue'

const routes = [
  // {
  //   path: "/",
  //   redirect: "/calculator",
  // },
  {
    //path: "/application-for-pick-up",
    path: '/',
    name: 'cargoPickup',
    component: newCargoPickUpPage,
  },
  {
    path: '/calculator',
    name: 'calculator',
    component: CalculatePage,
  },
  {
    path: '/forwardin-receipt',
    name: 'forwardingReceipt',
    component: ForwardinReceiptPage,
  },
  {
    path: '/cargo-status',
    name: 'cargoStatus',
    component: CargoStatusPage,
  },
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
